import { useMemo } from 'react';

import useAccountPricingPlanQuery from '../queries/useAccountPricingPlanQuery';

interface UseShowCancelInterruptParams {
  loyaltyVoucherIssued: boolean;
  numOfLoyaltyQualifiedSessions: number;
}

const useShowCancelInterrupt = ({
  loyaltyVoucherIssued,
  numOfLoyaltyQualifiedSessions,
}: UseShowCancelInterruptParams) => {
  const { data: accountPricingPlan, isLoading: isAccountPricingPlanLoading } = useAccountPricingPlanQuery();
  const currentPricingPlan = accountPricingPlan?.currentPricingPlan;

  const showCancelInterrupt = useMemo(() => {
    if (isAccountPricingPlanLoading || !currentPricingPlan) {
      return false;
    }
    // Checks if the pricing plan is eligible for loyalty vouchers,
    //  and if the enrolment has not received any loyalty vouchers yet
    //  and if the enrolment has not completed the required number of loyalty sessions
    const loyaltySessionsCompleted = numOfLoyaltyQualifiedSessions ?? 0;
    const loyaltySessionsRequired = currentPricingPlan.loyaltyVouchersSessionCompletion ?? 0;
    const hasIncompleteLoyaltySessions =
      loyaltySessionsCompleted < loyaltySessionsRequired ||
      (loyaltySessionsCompleted === 0 && loyaltySessionsRequired === 0);

    return currentPricingPlan.loyaltyVouchersEligible && !loyaltyVoucherIssued && hasIncompleteLoyaltySessions;
  }, [isAccountPricingPlanLoading, currentPricingPlan, loyaltyVoucherIssued, numOfLoyaltyQualifiedSessions]);

  return {
    showCancelInterrupt,
    currentPricingPlan,
    isAccountPricingPlanLoading,
  };
};

export default useShowCancelInterrupt;
